import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { Box } from 'src/components/Box';
import { Typography } from 'src/components/Typography';
import { SxProps, Theme } from 'src/components/muiTheme/utils';

import { Icon } from '../components/Icon';


interface CustomErrorObject {
  message?: string;
}

const getErrorMessage = (
  unknownError: string | Error | CustomErrorObject
): string => {
  if (typeof unknownError === 'string') {
    return unknownError;
  }
  if (
    unknownError &&
    Object.prototype.hasOwnProperty.call(unknownError, 'message') &&
    typeof unknownError.message === 'string'
  ) {
    return unknownError.message;
  }
  return 'Unknown error';
};

interface ErrorDisplayProps {
  sx?: SxProps<Theme>;
  compact?: boolean;
  errorMessage: string | Error | CustomErrorObject;
  title: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  title,
  errorMessage,
  sx,
  compact = false,
}) => {
  return (
    <Box sx={{ py: 3, px: 3, textAlign: 'center', ...sx }}>
      {!compact && (
        <Icon
          color="error"
          icon={faExclamationTriangle}
          size="large"
          sx={{ mb: 3 }}
        />
      )}
      <Typography color="error" variant="h6" sx={{ mb: 3 }} gutterBottom>
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        {getErrorMessage(errorMessage)}
      </Typography>
    </Box>
  );
};

